import React, { useState } from 'react';
import {
    Container,
    Typography,
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Paper,
    Grid,
    Button,
    Box,
    Snackbar
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import { can } from '../../Conections/LogConections';
import { CalificarBonoGroup, CalificarGroup, GetActivityDataAPI, GetBonosDataAPI, GetEstudentsArrayDataAPI, GetEstudentsDataAPI, GetPointsDataAPI } from '../../Conections/AcademicConection';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// Datos de ejemplo
const actividadEjemplo = {
    id: '0',
    nombre: "",
    descripcion: "",
    fecha: "",
    peso: 0,
    grupo: ""
};

const estudiantesEjemplo = [
    { id: 0, codigo: '', nombre: "", apellido: "" }
];

const puntosEjemplo = [
    { id: 0, nombre: "", peso: 0 }
];

function GradeUpComplete() {

    const location = useLocation();
    const goTo = useNavigate();
    const { getToken, getCompany } = useAuth();
    const params = useParams();

    const [bono, setBono] = useState([]);
    const [actividad, setActividad] = useState(actividadEjemplo);
    const [estudiantes, setEstudiantes] = useState(estudiantesEjemplo);
    const [actividadTitle, setActividadTitle] = useState("");
    const [puntos, setPuntos] = useState(puntosEjemplo);
    const [calificaciones, setCalificaciones] = useState(
        puntos.reduce((acc, punto) => ({
            ...acc,
            [punto.id]: { id: punto.id, valor: '' }
        }), {})
    );
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [errors, setErrors] = useState({});

    React.useEffect(() => {
        async function reloaduser() {
            if (getToken()) {
                const permisionCan = await can(getToken(), getCompany(), "/academic/bonouptwo/:activity/:bono");
                if (permisionCan === 0) {
                    goTo("/dashboard");
                }
                else {
                    const estuduantesSelect = location.state?.idsSeleccionados || [];
                    let Activity = await GetActivityDataAPI(getToken(), getCompany(), params["activity"]);
                    let Estudents = await GetEstudentsArrayDataAPI(getToken(), getCompany(), Activity["group"], estuduantesSelect);
                    let Points = await GetBonosDataAPI(getToken(), getCompany(), params["activity"]);
                    /* Para Cambio */
                    let Bonos = await GetBonosDataAPI(getToken(), getCompany(), params["activity"]);
                    const idBuscado = parseInt(params["bono"]);
                    const bonoData = Bonos.find(b => b.id === idBuscado);
                    console.log(bonoData);
                    setBono(bonoData);

                    let actividadChange = actividad;
                    actividadChange["id"] = Activity["id"];
                    setActividadTitle(Activity["name"]);
                    actividadChange["nombre"] = Activity["name"];
                    actividadChange["descripcion"] = Activity["description"];
                    actividadChange["peso"] = Activity["weigth"];
                    actividadChange["fecha"] = Activity["date"];
                    actividadChange["activa"] = Activity["show"] === 1;
                    setActividad(actividadChange);

                    const listEstudents = Estudents.map(Estudent => ({
                        id: Estudent.id,
                        codigo: Estudent.code,
                        nombre: Estudent.firstname,
                        apellido: Estudent.lastname
                    }));
                    setEstudiantes(listEstudents);

                    const selectedIds = [parseInt(params["bono"])]; // Lista de IDs que quieres incluir
                    const listPoint = Points
                        .filter(Point => selectedIds.includes(Point.id)) // Filtra solo los puntos con IDs en selectedIds
                        .map(Point => ({
                            id: Point.id,
                            nombre: Point.name,
                            peso: Point.valor,
                        }));
                    setPuntos(listPoint);
                    setCalificaciones(listPoint.reduce((acc, punto) => ({
                        ...acc,
                        [punto.id]: { id: punto.id, valor: '' }
                    }), {}));

                }
            }
            else {
                goTo(`/login`);
            }
        };
        reloaduser();
    }, [params, actividad, getCompany, getToken, goTo, actividadTitle, location]);

    const handleCalificacionChange = (puntoId, valor) => {
        const numeroValor = Number(valor);
        if (isNaN(numeroValor) || numeroValor < 0 || numeroValor > bono.value) return;

        setCalificaciones(prevCalificaciones => ({
            ...prevCalificaciones,
            [puntoId]: { ...prevCalificaciones[puntoId], valor }
        }));
        setErrors(prevErrors => ({ ...prevErrors, [puntoId]: { valor: false } }));
    };

    const handleEnviarCalificaciones = async () => {
        const newErrors = {};
        let hasErrors = false;

        Object.entries(calificaciones).forEach(([puntoId, { valor }]) => {
            console.log(calificaciones);
            newErrors[puntoId] = {};
            if (valor.trim() === '') {
                newErrors[puntoId].valor = true;
                hasErrors = true;
            }
        });

        setErrors(newErrors);

        if (hasErrors) {
            setSnackbarMessage('Por favor, complete todos los campos antes de enviar.');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
        } else {
            const estuduantesSelect = location.state?.idsSeleccionados || [];
            const datos = await CalificarBonoGroup(
                getToken(),
                getCompany(),
                params["activity"],
                estuduantesSelect,
                calificaciones
            );
            goTo(`/academic/bonoupone/${datos}/${params["bono"]}`);
        }
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    return (
        <Container maxWidth="lg">
            <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ my: 4 }}>
                Ingresar Calificación Grupal
            </Typography>

            <Grid container spacing={3} direction="column">
                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Datos de la Actividad
                            </Typography>
                            <Typography variant="body1">
                                <strong>Nombre:</strong> {actividad.nombre}
                            </Typography>
                            <Typography variant="body1">
                                <strong>Descripción:</strong> {actividad.descripcion}
                            </Typography>
                            <Typography variant="body1">
                                <strong>Bono:</strong> {bono.name}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Lista de Estudiantes
                            </Typography>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Código</TableCell>
                                            <TableCell>Nombre</TableCell>
                                            <TableCell>Apellido</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {estudiantes.map((estudiante) => (
                                            <TableRow key={estudiante.id}>
                                                <TableCell>{estudiante.codigo}</TableCell>
                                                <TableCell>{estudiante.nombre}</TableCell>
                                                <TableCell>{estudiante.apellido}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Ingresar Calificación Grupal
                            </Typography>
                            <Typography variant="body2" paragraph>
                                La calificación ingresada se aplicará a todos los miembros del grupo.
                            </Typography>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Criterio</TableCell>
                                            <TableCell align="center">Calificación (0-{bono.value})</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {puntos.map((punto) => (
                                            <TableRow key={punto.id}>
                                                <TableCell>{punto.nombre}</TableCell>
                                                <TableCell align="center">
                                                    <TextField
                                                        type="number"
                                                        InputProps={{
                                                            inputProps: {
                                                                min: 0,
                                                                max: bono.value,
                                                                step: 1
                                                            }
                                                        }}
                                                        value={calificaciones[punto.id].valor}
                                                        onChange={(e) => handleCalificacionChange(punto.id, e.target.value)}
                                                        variant="outlined"
                                                        size="small"
                                                        sx={{ width: '100px' }}
                                                        error={errors[punto.id]?.valor}
                                                        helperText={errors[punto.id]?.valor ? "Campo requerido" : ""}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleEnviarCalificaciones}
                                >
                                    Enviar Calificación
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default GradeUpComplete;

